import type { CompiledValidateFunction } from '@rjsf/validator-ajv8';
import type { ErrorObject } from 'ajv/dist/2019';

const localization =
	(t: (key: string, options?: Record<string, unknown>) => string): (() => CompiledValidateFunction) =>
	(errors: null | ErrorObject[] = []): CompiledValidateFunction => {
		if (!(errors && errors.length)) {
			return;
		}

		errors.map((error: ErrorObject) => {
			const { keyword } = error;

			let outMessage = '';

			switch (keyword) {
				case 'pattern': {
					// @ts-ignore
					outMessage = t('form.validation.pattern', { pattern: error.params?.pattern });

					break;
				}
				case 'required': {
					outMessage = t('form.validation.required');

					break;
				}
				case 'type': {
					outMessage = t('form.validation.type');

					break;
				}
				case 'minLength': {
					outMessage = t('form.validation.minLength');

					break;
				}
				case 'maxLength': {
					outMessage = t('form.validation.maxLength');

					break;
				}
				case 'enum': {
					outMessage = t('form.validation.enum');

					break;
				}
				case 'format': {
					outMessage = t('form.validation.format');

					break;
				}
				case 'minItems': {
					outMessage = t('form.validation.minItems');

					break;
				}
				case 'maximum': {
					outMessage = t('form.validation.maximum');

					break;
				}
				default:
					outMessage = t(`form.validation.${keyword}`);
			}

			// @ts-ignore
			error.message = outMessage;
		});
	};

export { localization };
